import script from "./SupportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportForm.vue?vue&type=script&setup=true&lang=js"

import "./SupportForm.vue?vue&type=style&index=0&id=49baba04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49baba04"]])

export default __exports__